var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('client-list',{attrs:{"table-columns":_vm.clientTableColumns}})}
var staticRenderFns = []

export { render, staticRenderFns }